import React from 'react';
import Loader from '../Loader/Loader';

interface IImageLoaderProps {
  width: string;
  height: string;
  containerBackground?: string;
  spinnerColor?: string;
  position?: string
}

const ImageLoader = ({
   width,
   height,
   containerBackground = 'transparent',
   spinnerColor = 'white',
   position = 'relative'
 }: IImageLoaderProps) => {
  const wrapperStyle = {
    width,
    height,
    background: containerBackground,
    position
  };

  return (
    // @ts-ignore
    <div className="image-loader-wrapper" style={wrapperStyle}>
      <Loader minHeight="100%" />
    </div>
  );
};

export default ImageLoader;
